// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
export var emojiTypeAhead = 'emoji-typeahead-element';
export var typeAheadListContainer = 'emoji-typeahead-list-container';

// editor-core is using this static class name for testing
export var typeaheadSelected = 'emoji-typeahead-selected';